angular.module('tf.directives')

    .directive("tfSidepanel",[function(){
        return {
            restrict: "E",
            replace:true,
            templateUrl: "js/components/sidepanel/sidepanel.html",
            controller : "SidepanelController"
        };

    }])

    .controller("SidepanelController",['$scope','AuthService','$state','$window','$timeout','$rootScope',
        function($scope, AuthService, $state, $window, $timeout,$rootScope) {
            $scope.isLoggedIn = AuthService.isAuthenticated;
            $scope.$state = $state;

            function toggleSidepanel(open){
                if(open !== undefined){
                    $scope.isOpen = open;
                } else {
                    $scope.isOpen = !$scope.isOpen;
                }
                try{
                    if($rootScope.templateSelector.isOpen()){
                        $rootScope.templateSelector.close();
                    }
                } catch(err){}
                return $scope.isOpen;
            }
            function isOpen(){
                return $scope.isOpen;
            }
            function open(){
                $scope.isOpen = true;
            }
            function close(){
                $scope.isOpen = false;
            }

            $rootScope.sidepanel = {
                toggle  : toggleSidepanel,
                isOpen  : isOpen,
                open    : open,
                close   : close
            };

            $(window).click(function() {
                if ($scope.isOpen) {
                    $scope.isOpen = false;
                    $scope.$apply();
                }
            });

        }]);